var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 3.55564C14.6666 3.06497 14.2941 2.66675 13.8333 2.66675C13.6033 2.66675 13.3941 2.7663 13.2433 2.92719L5.49992 11.1876L2.75659 8.26053C2.60575 8.09964 2.39659 8.00008 2.16659 8.00008C1.70575 8.00008 1.33325 8.3983 1.33325 8.88897C1.33325 9.1343 1.42575 9.35653 1.57742 9.51741L4.91075 13.073C4.98742 13.1547 5.07825 13.2196 5.17992 13.2641C5.28075 13.3094 5.38909 13.3334 5.49992 13.3334C5.60992 13.3334 5.71909 13.3094 5.81992 13.265C5.92159 13.2196 6.01242 13.1539 6.08992 13.073L14.4224 4.18497C14.5733 4.02319 14.6666 3.80097 14.6666 3.55564Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check_mark.34bac08962dabf51cca1fc9936e7a153.svg";
export { ForwardRef as ReactComponent };